export default [ 'ModalService', '$window', '$timeout', 'basketPopupService', (ModalService, $window, $timeout, basketPopupService) => {
  const prompt = {};

  prompt.openProblemPrompt = (title, text, issues) => {
    basketPopupService.remove();
    let issuelist = '';
    for (let issue of issues) {issuelist += '<li>' + issue + '</li>';}

    return ModalService.showModal({
      template:
                `<div class="c-prompt">
    <div class="c-prompt__header">
        ${title}
    </div>
    <div class="c-prompt__body">

        <p class="c-prompt__message">
            ${text}
        </p>

        <ul class="c-prompt__list">
            ${issuelist}
        </ul>

        <p class="c-prompt__pre-button">
            Would you like to remove this event?
        </p>

        <div class="c-prompt__buttons">
            <button class="c-button" ng-click="$ctrl.close('all')"><span class="c-button__text">confirm</span></button>
            <button class="c-button c-button--hollow" ng-click="$ctrl.close(false)"><span class="c-button__text">cancel</span></button>
        </div>
    </div>
</div>
<div class="c-prompt__overlay"></div>`,
      controller: 'promptController as $ctrl'
    });
  };

  prompt.openLoginPrompt = (title, text, passwordOnly = false) => {
    basketPopupService.remove();
    $timeout(() => {
      $window.dispatchEvent(new CustomEvent('initCalendar'));
    }, 250);

    return ModalService.showModal({
      template:
                `<div class="c-prompt c-prompt--login">
    <div class="c-prompt__header">
        ${title}
    </div>
    <div class="c-prompt__body" ng-if="!$ctrl.success">

        <p class="c-prompt__info" ng-if="!$ctrl.basket.empty()">Please be aware, logging in will clear your basket.</p>

        <p class="c-checkout__error" ng-if="$ctrl.error" ng-bind-html="$ctrl.error"></p>

        <div class="c-prompt__tabs" ng-if="${!passwordOnly}">
            <button class="c-prompt__tab" ng-click="$ctrl.setTab('password')" ng-class="{'is-active': !$ctrl.tab || $ctrl.activeTab('password')}">With Password</button>
            <button class="c-prompt__tab" ng-click="$ctrl.goToManageBooking()" ng-class="{'is-active': $ctrl.activeTab('reference')}">With Reference</button>
        </div>

        <div ng-show="!$ctrl.tab || $ctrl.activeTab('password')">

            <p class="c-prompt__message">
                ${text}
            </p>

            <form ng-submit="$ctrl.login()">
                <div class="c-prompt__inputs">
                    <div class="c-form__field">
                        <input name="EmailAddress" class="c-form__input / c-prompt__email" type="email" autocomplete="email" ng-model="$ctrl.email" required ng-disabled="$ctrl.saving" autofocus>
                        <label class="c-form__label t-text--secondary" for="EmailAddress">Email Address</label>
                    </div>
                    <div class="c-form__field">
                        <input name="Password" class="c-form__input / c-prompt__password" type="password" autocomplete="password" ng-model="$ctrl.password" required ng-disabled="$ctrl.saving">
                        <label class="c-form__label t-text--secondary" for="Password">Password</label>
                    </div>
                </div>

                <div class="c-prompt__buttons">
                    <button class="c-button" type="submit" ng-disabled="$ctrl.saving" data-dismiss="modal">
                        <span class="c-button__text" ng-hide="$ctrl.saving">Log in</span>
                        <spinner ng-show="$ctrl.saving"></spinner>
                    </button>
                    <button class="c-button c-button--hollow" type="button" ng-disabled="$ctrl.saving" ng-if="$ctrl.isGuestAllowed()" ng-click="$ctrl.closePrompt()" data-dismiss="modal">
                        <span class="c-button__text" ng-hide="$ctrl.saving">Continue as a Guest</span>
                        <spinner ng-show="$ctrl.saving"></spinner>
                    </button>
                    <a href="/register" class="c-button c-button--hollow" ng-if="$ctrl.canRegister()" ng-disabled="$ctrl.saving" data-dismiss="modal">
                        <span class="c-button__text" ng-hide="$ctrl.saving">Register</span>
                        <spinner ng-show="$ctrl.saving"></spinner>
                    </a>
                </div>
            </form>
        </div>
    </div>

    <p class="c-prompt__success" ng-if="$ctrl.success" ng-bind-html="$ctrl.success"></p>

    <button class="c-prompt__close" ng-click="$ctrl.closePrompt()" title="Close">
        <span class="show-for-sr">Close the login form</span> &times;
    </button>
</div>
<div class="c-prompt__overlay"></div>`,
      controller: 'promptController as $ctrl'
    })
      .then((modal) => {
        return modal.close
          .then(response => response);
      });
  };

  prompt.openLogoutPrompt = (title) => {
    basketPopupService.remove();
    return ModalService.showModal({
      template:
                `<div class="c-prompt c-prompt--login">
    <div class="c-prompt__header">
        ${title}
    </div>
    <div class="c-prompt__body">

        <p class="c-prompt__info">Are you sure you want to log out? <br />Logging out will clear your basket.</p>

        <form ng-submit="$ctrl.logout()">
            <div class="c-prompt__buttons">
                <button class="c-button c-button--fail" type="submit" ng-disabled="$ctrl.saving">
                    <span class="c-button__text" ng-hide="$ctrl.saving">Yes, log out</span>
                    <spinner ng-show="$ctrl.saving"></spinner>
                </button>

                <button class="c-button c-button--hollow" type="button" ng-disabled="$ctrl.saving" ng-click="$ctrl.close(false)">
                    <span class="c-button__text" ng-hide="$ctrl.saving">No, stay logged in</span>
                    <spinner ng-show="$ctrl.saving"></spinner>
                </button>
            </div>
        </form>
    </div>

    <button class="c-prompt__close" ng-click="$ctrl.close(false)" title="Close">
        <span class="show-for-sr">Close the logout prompt</span> &times;
    </button>
</div>
<div class="c-prompt__overlay"></div>`,
      controller: 'promptController as $ctrl'
    })
      .then((modal) => {
        return modal.close
          .then(response => response);
      });
  };

  prompt.openStopReservationPrompt = (title) => {
    basketPopupService.remove();
    return ModalService.showModal({
      template:
                `<div class="c-prompt c-prompt--login">
    <div class="c-prompt__header">
        ${title}
    </div>
    <div class="c-prompt__body">

        <p class="c-prompt__info">Are you sure you want to logout? <br />Logging out will clear your basket and stop any additions persisting.</p>

        <form ng-submit="$ctrl.logout()">
            <div class="c-prompt__buttons">
                <button class="c-button c-button--fail" type="submit" ng-disabled="$ctrl.saving">
                    <span class="c-button__text" ng-hide="$ctrl.saving">Yes, logout</span>
                    <spinner ng-show="$ctrl.saving"></spinner>
                </button>

                <button class="c-button c-button--hollow" type="button" ng-disabled="$ctrl.saving" ng-click="$ctrl.close(false)">
                    <span class="c-button__text" ng-hide="$ctrl.saving">No, keep editing</span>
                    <spinner ng-show="$ctrl.saving"></spinner>
                </button>
            </div>
        </form>
    </div>

    <button class="c-prompt__close" ng-click="$ctrl.close(false)" title="Close">
        <span class="show-for-sr">Close the logout prompt</span> &times;
    </button>
</div>
<div class="c-prompt__overlay"></div>`,
      controller: 'promptController as $ctrl'
    })
      .then((modal) => {
        return modal.close
          .then(response => response);
      });
  };

  return prompt;
} ];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/guest/services/prompt.service.js